/**
 * ResourceTypeService
 * Service for ResourceType entity operations
 * Route: api/resource-types
 * Controller: ResourceTypeController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ResourceTypeService
 * Handles resource type CRUD operations
 * Maps to /api/resource-types endpoint
 */
export class ResourceTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ResourceTypeService.DEFAULT_SERVICE_PATH,
            basePath: ResourceTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ResourceTypeService.DEFAULT_SERVICE_PATH = 'projects';
ResourceTypeService.BASE_PATH = 'api/resource-types';
//# sourceMappingURL=ResourceTypeService.js.map